/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutGroupBase,
  OptOutGroupBaseOptional,
  OptOutGroupBaseMetaI,
  OptOutGroupBaseTrackedI,
} from "./opt-out-group-base";
import {
  OptOutGroupBaseTracked,
  OptOutGroupBaseMeta,
} from "./opt-out-group-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutGroupRef,
  OptOutGroupRefOptional,
  OptOutGroupRefMetaI,
  OptOutGroupRefTrackedI,
} from "./opt-out-group-ref";
import { OptOutGroupRefTracked, OptOutGroupRefMeta } from "./opt-out-group-ref";

/**
 *
 * @export
 * @interface OptOutGroupFull
 */
export interface OptOutGroupFullOptional extends OptOutGroupBaseOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutGroupFull
   */
  optOutGrpId?: number;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  groupName?: string;
  /**
   * When true, requires explicit opt-in for emails to be sent (inverts normal opt-out logic)
   * @type {boolean}
   * @memberof OptOutGroupFull
   */
  requireOptIn?: boolean;
}

export interface OptOutGroupFull
  extends OptOutGroupFullOptional, OptOutGroupBase, OptOutGroupRef {
  /**
   *
   * @type {number}
   * @memberof OptOutGroupFull
   */
  optOutGrpId: number;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  groupName?: string;
  /**
   * When true, requires explicit opt-in for emails to be sent (inverts normal opt-out logic)
   * @type {boolean}
   * @memberof OptOutGroupFull
   */
  requireOptIn?: boolean;
}

export interface OptOutGroupFullTrackedI extends OptOutGroupBaseOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutGroupFull
   */
  optOutGrpId?: number;
  optOutGrpIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutGroupFull
   */
  groupName?: string;
  groupNameIsSet: boolean;
  /**
   * When true, requires explicit opt-in for emails to be sent (inverts normal opt-out logic)
   * @type {boolean}
   * @memberof OptOutGroupFull
   */
  requireOptIn?: boolean;
  requireOptInIsSet: boolean;
}

transformDatesMap.set("OptOutGroupFull", function (model: OptOutGroupFull) {
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
});

export type OptOutGroupFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  optOutGrpId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  groupName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  requireOptIn: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var OptOutGroupFullMeta: OptOutGroupFullMetaI =
  {} as OptOutGroupFullMetaI;
OptOutGroupFullMeta = typeMeta("OptOutGroupFull", {
  optOutGrpId: propertyMeta(
    "optOutGrpId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  groupName: propertyMeta(
    "groupName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  requireOptIn: propertyMeta(
    "requireOptIn",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = OptOutGroupFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([OptOutGroupRefMeta]);
  metaI.optOutGrpId.inheritedFrom = OptOutGroupRefMeta.optOutGrpId;
  metaI.interfaces = metaI.interfaces.concat([OptOutGroupBaseMeta]);
  metaI.updatedOn.inheritedFrom = OptOutGroupBaseMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = OptOutGroupBaseMeta.updatedBy;
  metaI.createdOn.inheritedFrom = OptOutGroupBaseMeta.createdOn;
  metaI.createdBy.inheritedFrom = OptOutGroupBaseMeta.createdBy;
  metaI.groupName.inheritedFrom = OptOutGroupBaseMeta.groupName;
  metaI.requireOptIn.inheritedFrom = OptOutGroupBaseMeta.requireOptIn;
});

export class OptOutGroupFullTracked
  extends OptOutGroupBaseTracked
  implements OptOutGroupFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  optOutGrpId__I?: number = undefined;

  get optOutGrpIdIsSet() {
    return this.optOutGrpId !== undefined;
  }
  set optOutGrpIdIsSet(v: boolean) {}
  set optOutGrpId(v: undefined | number) {
    if (v !== undefined) {
      this.optOutGrpId__I = v;
      this.optOutGrpIdIsSet = true;
    } else {
      this.optOutGrpId__I = v || undefined;
      this.optOutGrpIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get optOutGrpId() {
    return this.optOutGrpId__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  groupName__I?: string = undefined;
  groupNameIsSet: boolean = false;
  set groupName(v: undefined | string) {
    if (v !== undefined) {
      this.groupName__I = v;
      this.groupNameIsSet = true;
    } else {
      this.groupName__I = v || undefined;
      this.groupNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get groupName() {
    return this.groupName__I;
  }
  requireOptIn__I?: boolean = undefined;
  requireOptInIsSet: boolean = false;
  set requireOptIn(v: undefined | boolean) {
    if (v !== undefined) {
      this.requireOptIn__I = v;
      this.requireOptInIsSet = true;
    } else {
      this.requireOptIn__I = v || undefined;
      this.requireOptInIsSet = false;
    }
    this.changeTracker = true;
  }
  get requireOptIn() {
    return this.requireOptIn__I;
  }
  constructor(config?: OptOutGroupFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.optOutGrpIdIsSet == true && other?.optOutGrpIdIsSet == true)
      return this.optOutGrpId == other.optOutGrpId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.optOutGrpId) {
      this.optOutGrpIdIsSet = true;
    }
  }
  assignFrom(
    config: OptOutGroupFullOptional,
    options?: AssignOptions,
  ): OptOutGroupFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.optOutGrpId &&
      this.optOutGrpIdApplyFilter(optionsRequired.filter)
    ) {
      this.optOutGrpId = config.optOutGrpId;
      if (optionsRequired.unassign) this.optOutGrpIdIsSet = false;
      else this.optOutGrpIdIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.groupName && this.groupNameApplyFilter(optionsRequired.filter)) {
      this.groupName = config.groupName;
      if (optionsRequired.unassign) this.groupNameIsSet = false;
      else this.groupNameIsSet = true;
    }
    if (
      config.requireOptIn &&
      this.requireOptInApplyFilter(optionsRequired.filter)
    ) {
      this.requireOptIn = config.requireOptIn;
      if (optionsRequired.unassign) this.requireOptInIsSet = false;
      else this.requireOptInIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutGroupFullTrackedI {
    const cloned = {} as OptOutGroupFullTrackedI;
    if (
      this.optOutGrpIdIsSetDeep() &&
      this.optOutGrpIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optOutGrpIdIsSet = true;
      cloned.optOutGrpId = this.optOutGrpId;
    } else {
      //cloned.optOutGrpIdIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.groupNameIsSetDeep() &&
      this.groupNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.groupNameIsSet = true;
      cloned.groupName = this.groupName;
    } else {
      //cloned.groupNameIsSet = false
    }
    if (
      this.requireOptInIsSetDeep() &&
      this.requireOptInApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.requireOptInIsSet = true;
      cloned.requireOptIn = this.requireOptIn;
    } else {
      //cloned.requireOptInIsSet = false
    }
    if (!isDeleted(this) && !this.optOutGrpIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutGroupFullTrackedI {
    if (!this.optOutGrpIdApplyFilter(filter)) this.optOutGrpIdIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.groupNameApplyFilter(filter)) this.groupNameIsSet = false;

    if (!this.requireOptInApplyFilter(filter)) this.requireOptInIsSet = false;

    return this;
  }
  optOutGrpIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupFullMeta.optOutGrpId,
      OptOutGroupFullMeta,
      this.optOutGrpId,
      this,
    );
  }
  optOutGrpIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optOutGrpIdIsSet && this.optOutGrpIdApplyFilter(filter))
      return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupFullMeta.updatedOn,
      OptOutGroupFullMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupFullMeta.updatedBy,
      OptOutGroupFullMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupFullMeta.createdOn,
      OptOutGroupFullMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupFullMeta.createdBy,
      OptOutGroupFullMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  groupNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupFullMeta.groupName,
      OptOutGroupFullMeta,
      this.groupName,
      this,
    );
  }
  groupNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.groupNameIsSet && this.groupNameApplyFilter(filter)) return true;

    return false;
  }
  requireOptInApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutGroupFullMeta.requireOptIn,
      OptOutGroupFullMeta,
      this.requireOptIn,
      this,
    );
  }
  requireOptInIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.requireOptInIsSet && this.requireOptInApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.optOutGrpIdIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.groupNameIsSetDeep(filter)) return true;
    if (this.requireOptInIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
